import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  bad: 'La misma pregunta todos los días',
  good: 'Menú cerrado semana a semana'
}, {
  bad: 'Siempre las mismas 5 comidas',
  good: '90+ recetas con variedad real'
}, {
  bad: 'Delivery de emergencia',
  good: 'Comida casera en 20-35 minutos'
}, {
  bad: 'Domingo perdido planificando',
  good: 'Semana resuelta en 10 minutos'
}, {
  bad: 'Heladera sin ideas',
  good: 'Lista de compras organizada'
}, {
  bad: 'Familia aburrida',
  good: 'Cada semana algo diferente'
}];
export const ComparisonSection = () => {
  return <section className="py-16 px-4 bg-gray-900 border-y border-orange-900/50" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-55">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-56">
            🔄 ANTES VS. DESPUÉS
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full" data-id="element-57"></div>
        </motion.div>

        <div className="overflow-x-auto pb-4" data-id="element-58">
          <div className="min-w-[600px] w-full" data-id="element-59">
            <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-60">
              <div className="bg-red-900/20 border-2 border-red-500/50 rounded-t-xl p-4 text-center" data-id="element-61">
                <h3 className="text-2xl font-bold text-red-500 flex items-center justify-center gap-2" data-id="element-62">
                  <X className="w-8 h-8" data-id="element-63" /> Antes
                </h3>
              </div>
              <div className="bg-orange-900/20 border-2 border-orange-500 rounded-t-xl p-4 text-center" data-id="element-64">
                <h3 className="text-2xl font-bold text-orange-500 flex items-center justify-center gap-2" data-id="element-65">
                  <Check className="w-8 h-8" data-id="element-66" /> Después
                </h3>
              </div>
            </div>

            <div className="space-y-3" data-id="element-67">
              {comparisons.map((row, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="grid grid-cols-2 gap-4" data-id="element-68">
                  <div className="bg-black border border-red-900/30 rounded-lg p-4 flex items-center" data-id="element-69">
                    <p className="text-gray-400 font-medium" data-id="element-70">{row.bad}</p>
                  </div>
                  <div className="bg-orange-900/10 border border-orange-500/50 rounded-lg p-4 flex items-center" data-id="element-71">
                    <p className="text-white font-bold" data-id="element-72">{row.good}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
        <p className="text-center text-gray-500 text-sm mt-2 md:hidden" data-id="element-73">
          ← Deslizá para ver tabla completa →
        </p>
      </div>
    </section>;
};